import * as React from "react";
import { cn } from "../../lib/utils";
import { useColorPreference } from "../../hooks/useColorPreference";
import jyloLogo from "../../assets/logo-jylo-combined.png";
import jyloLogoOnDark from "../../assets/logo-jylo-combined-dark.png";

/**
 * The full Jylo logo in the scheme on screen. The wordmark is navy in the light
 * rendering and white in the dark one; the mark is the brand blue in both. The two
 * files are the designer's own exports, so pick between them here rather than
 * restyling one with a filter.
 */
const JyloLogo = ({ height, className }: { height: number; className?: string }) => {
  const { mode } = useColorPreference();

  return (
    <img
      src={mode === "dark" ? jyloLogoOnDark : jyloLogo}
      alt="Jylo"
      style={{ height }}
      className={cn("block", className)}
    />
  );
};

export default JyloLogo;
